<template>
  <RevContainer>
    <div class="pt-32 pb-16">
      <div class="mx-auto">
        <h2 class="heading-3 mb-24">
          {{ title || i18n(translations.mainTitle) }}
        </h2>
        <RevTabs
          v-if="sections.length > 1"
          class="mb-32"
          :label="i18n(translations.tabsLabel)"
          variant="flexible"
        >
          <RevTabItem
            v-for="(section, index) in sections"
            :key="index"
            :active="activeTabIndex === index"
            :label="section.title"
            @click="activeTabIndex = index"
          />
        </RevTabs>
        <template v-for="(section, index) in sections" :key="section.title">
          <h3 v-show="activeTabIndex === index" class="heading-3 mb-24">
            {{ section.title }}
          </h3>
          <div v-show="activeTabIndex === index" class="mt-24">
            <SeoFooterLinks
              :links="section.links"
              :see-more-label="i18n(translations.seeMore)"
              @link-click="emit('link-click', $event)"
            />
          </div>
        </template>
      </div>
    </div>
  </RevContainer>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevContainer } from '@ds/components/Container'
import { RevTabItem } from '@ds/components/TabItem'
import { RevTabs } from '@ds/components/Tabs'

import type { SeoSection } from './SeoFooterLinks.types'
import SeoFooterLinks from './SeoFooterLinks.vue'
import translations from './SeoProductLinks.translations'

const i18n = useI18n()

const emit = defineEmits<{
  (e: 'link-click', product: { label: string; position: number }): void
}>()

defineProps<{
  sections: SeoSection[]
  title?: string | null
}>()

const activeTabIndex = ref(0)
</script>
